<section id="" class="content-padding">
  <div class="narrow-wrapper">
    <form class="has-cols" [formGroup]="timingForm" (ngSubmit)="onSubmit()">
      <div class="delivery-colle-data-box">
        <fieldset>
          <legend>Valet Start and End Time:</legend>

          <div class="col-48 grid-element">
            <label>Real Start and End Time</label>
            <div class="time-range">
              <div>
                <input
                  type="time"
                  formControlName="startTime"
                  [readonly]="groups.includes('partner')"
                />
              </div>
              <div style="text-align: center">&nbsp;-&nbsp;</div>
              <div>
                <input 
                  type="time" 
                  formControlName="endTime"
                  [readonly]="groups.includes('partner')"
                />
              </div>
            </div>
          </div>

          <div class="col-48 grid-element" *ngIf="groups.includes('partner')">
            <label>Updated Valet Start and End Time</label>
            <div class="time-range">
              <div>
                <input
                  type="time"
                  formControlName="valetStartTime"
                  (change)="handleValetStartTimeChange($event.target.value)"
                  [readonly]="groups.includes('partner')"
                />
              </div>
              <div style="text-align: center">&nbsp;-&nbsp;</div>
              <div>
                <input
                  type="time"
                  formControlName="valetEndTime"
                  (change)="handleValetEndTimeChange($event.target.value)"
                  [readonly]="groups.includes('partner')"
                />
              </div>
            </div>
          </div>

          <br class="clear" />
          <div class="col-48 grid-element" *ngIf="groups.includes('partner')">
            <label>Check For Approved Uncheck For Not Approved</label>
            <label class="original-label">
              <input
                type="checkbox"
                formControlName="approvedTimingStatus"
              />
              APPROVED STATUS
            </label>
          </div>
        </fieldset>
      </div>
      <div class="center mt-20">
        <button
          class="btn hvr-shrink center"
          (click)="$event.preventDefault(); onSubmit()"
          [disabled]="btnDisabled || !timingForm.valid"
        >
          Salva
          <i class="ml-10 far fa-save"></i>
        </button>
      </div>
    </form>
  </div>
</section>
